/* eslint-disable no-param-reassign */
import { get, axiosErrorHandler } from 'models/shared/helpers/axiosInstance';
import {
	ReferralCode,
	ReferralsResponse,
} from '../interfaces/referral-code.interface';

const baseReferralPath = '/v1/referral-code';

export const getReferrals = async (ozonerId: string) => {
	try {
		const res = await get<ReferralsResponse[]>(
			`${baseReferralPath}/referrals/${ozonerId}`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
export const getReferralCodeOzoner = async (ozonerId: string) => {
	try {
		const res = await get<ReferralCode>(
			`${baseReferralPath}/ozoner/${ozonerId}`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
export const getReferralCode = async (referralCode: string) => {
	try {
		const res = await get<ReferralCode>(`${baseReferralPath}/${referralCode}`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
